import { useEffect, useState } from "react";
import { auth } from "@/utils/firebase";
import { sendEmailVerification } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/nav-logo.svg";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        if (user.emailVerified) {
          navigate("/home");
          return;
        }

        const lastSent = localStorage.getItem("lastEmailSent");
        const oneHour = 60 * 60 * 1000;

        if (!lastSent || Date.now() - lastSent > oneHour) {
          try {
            await sendEmailVerification(user);
            console.log("Verification email sent!");
            localStorage.setItem("lastEmailSent", Date.now());
          } catch (error) {
            console.error("Error sending verification email:", error);
          }
        }

        // Auto-refresh the page every 10 seconds
        const interval = setInterval(() => {
          window.location.reload();
        }, 10000);

        return () => {
          clearInterval(interval);
          unsubscribe(); // Ensure proper cleanup
        };
      }
    });

    return () => unsubscribe(); // Ensuring cleanup
  }, [navigate]);

  return (
    <div className="font-sans">
      {/* Navbar */}
      <nav className="px-0 md:px-6 py-4 bg-black shadow-md">
        <div className="container mx-auto flex justify-between items-center">
          <div
            onClick={() => navigate("/")}
            className="flex items-center cursor-pointer"
          >
            <img src={Logo} className="h-14 w-14 mr-1" alt="Logo" />
            <div className="md:text-xl font-bold text-green">JP Associates</div>
          </div>
        </div>
      </nav>
      {/* Modal */}
      {showModal && (
        <VerificationModal onRefresh={() => window.location.reload()} />
      )}
    </div>
  );
};

const VerificationModal = ({ onRefresh }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-md text-center">
        <h2 className="text-xl font-bold mb-4">Verify Your Email</h2>
        <p className="mb-4">
          We have sent a verification email. Please check your inbox and verify
          your email to continue.
        </p>
        <button
          onClick={onRefresh}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default VerifyEmail;
